export default __webpack_public_path__ + "static/media/symbol-icn-check.d04504cd.svg";